import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '@core/frontend-shared';
import { MAINTENANCE_MODE_HEADER } from '@common/maintenance/shared';
import { AppMessage } from "@core/frontend-shared";
import { Store } from '@ngxs/store';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MaintenanceFacade, MaintenanceState } from '../state/maintenance.state';
import * as i0 from "@angular/core";
import * as i1 from "../state/maintenance.state";
import * as i2 from "@core/frontend-shared";
export let MaintenanceModeInterceptor = /*#__PURE__*/(() => {
  class MaintenanceModeInterceptor {
    constructor(facade, config) {
      this.facade = facade;
      this.config = config;
      this.whitelisted$ = inject(Store).select(MaintenanceState.whitelisted);
      this.mmEnabled$ = inject(Store).select(MaintenanceState.maintenanceModeEnabled);
      this.mmEnabled = false;
      this.whitelisted = false;
      this.whitelisted$.subscribe(whitelisted => {
        this.whitelisted = whitelisted;
      });
      this.mmEnabled$.subscribe(mmEnabled => {
        this.mmEnabled = mmEnabled;
      });
    }
    intercept(request, next) {
      const apiBaseUrl = this.config.buildPlatformUrl("backend", "");
      const isApiRequest = request.url.includes(apiBaseUrl);
      if (!isApiRequest) {
        // ensure non-api requests are let through even when maintenance mode is enabled
        return next.handle(request);
      } else {
        // if MM is already enabled, reject immediately
        if (this.mmEnabled && !this.whitelisted) {
          return throwError(() => new Error('Maintenance Mode enabled, aborting API request!'));
        }
        // send API request
        return next.handle(request).pipe(tap(res => {
          // request was successful, but we may be whitelisted with maintenance mode being enabled
          if (res instanceof HttpResponse) {
            if (res.headers.has(MAINTENANCE_MODE_HEADER)) {
              this.facade.enableMaintenanceMode("Maintenance mode enabled, client is whitelisted", true);
            }
          }
        }), catchError(err => {
          let httpError;
          if (err instanceof AppMessage) {
            err.discard();
            httpError = err.originalError;
          } else {
            httpError = err;
          }
          const shouldEnableMM = httpError.status === 503;
          if (shouldEnableMM) {
            const message = httpError.error.message;
            this.facade.enableMaintenanceMode(message);
            return throwError(() => new Error('Maintenance Mode enabled'));
          } else {
            return throwError(() => err);
          }
        }));
      }
    }
    static {
      this.ɵfac = function MaintenanceModeInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaintenanceModeInterceptor)(i0.ɵɵinject(i1.MaintenanceFacade), i0.ɵɵinject(i2.ConfigService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MaintenanceModeInterceptor,
        factory: MaintenanceModeInterceptor.ɵfac
      });
    }
  }
  return MaintenanceModeInterceptor;
})();